import React from 'react';
import { Link, withRouter } from "react-router-dom";

//layout
import Grid from '@material-ui/core/Grid'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Home from '@material-ui/icons/Home'
import Typography from '@material-ui/core/Typography'
import {withStyles} from '@material-ui/core/styles';
import CardPanel from '../Dashboard/CardPanel'

//service 
import DashboardService from '../../services/DashboardService'


const useStyles = theme => ({
  root: {
    marginTop: 20,
  },
  paper: {
    padding: theme.spacing(2),      
    color: theme.palette.text.secondary,    
  }, 
});

class DashboardPage extends React.Component {

  constructor(props){
    super(props);         
    this.refFlexmonster = React.createRef(); 
    this.state = {
      id: this.props.match.params.id,
      dataset:[],
      dashBoardContent:{}
    }
  }

  componentDidMount(prevProps) {  
    this.loadingAll()
  }

  componentDidUpdate(prevProps) {   
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.loadingAll()      
    }
  }

  loadingAll = () => {
    const response = DashboardService.searchById(this.props.match.params.id);    
    response
      .then((respUI) => {          
        this.setState({
          dataset: respUI.data.datasetDynamics, 
          dashBoardContent: respUI.data.dashboard
        })      
    })       
    .catch((error) => {
      console.error(error)
    })
  }

  render(){
    
    const { classes } = this.props;

    return (
      
      <div>
        
          <Grid item xs={12} >
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" to="/"  >
                <Home/>
              </Link>                                       
              <Typography color="textPrimary">{this.state.dashBoardContent.name}</Typography>
            </Breadcrumbs>
          
          </Grid>

          <Grid item xs={12} ><hr/></Grid>

          <Grid container spacing={2}>                                 
            {this.state.dataset.map((data, index) => <CardPanel key={index} dataset={data}/>)}            
          </Grid>  

      </div>
    )
  }
}


export default withStyles(useStyles)(withRouter(DashboardPage))